import { render, staticRenderFns } from "./UpdateSuppliedGoodForm.vue?vue&type=template&id=4750d1c7&scoped=true&"
import script from "./UpdateSuppliedGoodForm.vue?vue&type=script&lang=js&"
export * from "./UpdateSuppliedGoodForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4750d1c7",
  null
  
)

export default component.exports